import HuffmanTree from "./HuffmanTree";

export default HuffmanTree;
